const REQUEST_ORGANIZATION_USERS = 'REQUEST_ORGANIZATION_USERS';
const REQUEST_ORGANIZATION_USERS_FAIL = 'REQUEST_ORGANIZATION_USERS_FAIL';
const REQUEST_ORGANIZATION_USERS_SUCCESS = 'REQUEST_ORGANIZATION_USERS_SUCCESS';

export {
  REQUEST_ORGANIZATION_USERS,
  REQUEST_ORGANIZATION_USERS_FAIL,
  REQUEST_ORGANIZATION_USERS_SUCCESS,
};
